import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GraphyService } from '../graphy.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-graphy-learner-list',
  templateUrl: './graphy-learner-list.component.html',
  styleUrls: ['./graphy-learner-list.component.scss', "../../../../../../assets/sass/libs/datatables.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GraphyLearnerListComponent implements OnInit {
  learners: any[] = [];
  loading = true;
  columns = [
    { prop: 'name', name: 'Name' },
    { prop: 'email', name: 'Email' },
    { prop: 'mobile', name: 'Mobile' },
    { prop: 'status', name: 'Status' },
    { prop: 'enrollment.courseName', name: 'Course' },
    { prop: 'enrollment.courseLink', name: 'Course Link' },
    { prop: 'enrollment.assignedThrough', name: 'Assigned Through' },
    { prop: 'enrollment.courseValidity', name: 'Validity' },
    { prop: 'createdAt', name: 'Created At' ,pipe:new DatePipe('en-US')},
  ];
  learner_status=[
    // 'pending', 'live','classroom','completed'
    {name:"Pending",_id:"pending"},
    {name:"Live",_id:"live"},
    {name:'Classroom' , _id:'classroom'},
    {name:'Completed' , _id:'completed'}
  ]
  activeTab='pending';
  constructor(private graphyService: GraphyService, 
    private activatedRoute: ActivatedRoute,
    private route:Router
  ) {
    this.activatedRoute.params
    .subscribe((params: any) => {
     if(params?.status) this.activeTab = params?.status;
      this.getLearners(this.activeTab)
    })
  }
  activeLearnerTab(tab_id) {
    const activetab = tab_id;
    if (activetab !== '') {
      this.route.navigate(
        [`/graphy/enrollments/${tab_id}`],
      );
    } 
}
  ngOnInit(): void {
   
  }
  getLearners(status){
    this.graphyService.getLearners(status).subscribe({
      next: (res) => {
        this.learners = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
} 